import type { HTMLAttributes, ReactNode } from "react";

import { pathToLogin } from "@/src/app/paths";
import { ButtonLink } from "@/src/components/ui/Button/ButtonLink";

export function LoginButton({
  className,
}: HTMLAttributes<HTMLAnchorElement>): ReactNode {
  // Using an absolute link, in order to have an <a> rather than a <Link>
  // because of https://github.com/auth0/nextjs-auth0/issues/757
  const href = process.env.NEXT_PUBLIC_BASE_URL + pathToLogin();
  return (
    <ButtonLink className={className} darkBackground href={href} size="medium">
      Me connecter / adhérer
    </ButtonLink>
  );
}
